import Vue from 'vue'
import Router from 'vue-router'
import login from '../components/public/login'
import Layout from '../components/public/layout'

Vue.use(Router)

export default new Router({

  routes: [
    {
        path: '/',
        name: 'login',
        component: login,
        meta:{title:'艾媒数聚后台管理系统'},
        hidden: true
    },
    {
        path: 'layout',
        name: 'layout',
        component: Layout,
        meta:{title:'艾媒数聚后台管理系统'},
        hidden: true
    },
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js